import { useMutation } from '@tanstack/react-query';

import api from './api';

export const useAuthMutation = () => {
  return useMutation({
    mutationFn: async ({ credit ,token}) => {
      const res = await api.post(`/user/signup`, {credit ,token});
     
      sessionStorage.setItem("token", res.data.token);
      sessionStorage.setItem('email',res.data.email)
      return res.data;
    }
  });
};